import React from "react";
import TypoGraphyKit from "../../kit/typoGraphy";
import { CircularProgress } from "@mui/material";
import StackKit from "../../kit/stack";
import CustomButton from "../../kit/button";

const LoadingButton = ({
  isPending,
  title,
  onSubmit,
  type="button"
}: {
  isPending?: boolean;
  title: string;
  onSubmit?:()=> void;
  type?:"button" | "submit" | "reset" | undefined
}) => {
  return (
      <CustomButton
      type={type}
              onClick={onSubmit}
              variant="contained"
              sx={{ mt: 3, width:isPending ? "12%" :  "fit-content", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              {isPending ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                            <TypoGraphyKit variant="body1">{title}</TypoGraphyKit>

              )}
            </CustomButton>
  );
};

export default LoadingButton;
